<div class="fab-container">
    <div class="fab-actions" [class.open]="isOpen()">
        <ng-content></ng-content>
    </div>
    <button class="fab-main" (click)="toggle()" [class.open]="isOpen()" [pTooltip]="isOpen() ? undefined : 'Abrir menú'">
        <i [class]="isOpen() ? 'pi pi-times' : 'pi pi-sliders-h'"></i>
    </button>
</div>